//import React from 'react';
// 3) HELMET - Add this import to each page
import React, { Fragment, useState, useRef, useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import ScrollTrigger from 'gsap/ScrollTrigger';
import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
import {MotionPathPlugin} from '../js/MotionPathPlugin.js';

import heroimg_archive from '../images/heros/archive.webp';// Tell webpack this JS file uses this image
import heroimg_archive_top from '../images/heros/archive-ufo-glow.webp';
import heroimg_archive_beam from '../images/heros/archive-beam.webp';


//import services_img_1 from '../images/services-page-web-development.webp'; 
//import services_img_2 from '../images/services-graphic-design.png'; 




const Archive = () => {

  const bgfx_ref_8 = useRef();



useGSAP(() => {

    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(DrawSVGPlugin);
    gsap.registerPlugin(MotionPathPlugin);

    //Preset PAGE TRANSITION BACKGROUND
   gsap.set(".archive-transition-curtain", {left:"-4000", top:"-4000"});

// ========================= //
// HERO ANIMATION 
// ========================= //

const tl_ufo = gsap.timeline({repeat:-1});	
	

// UFO Dashed Array Animation
function heroAnimationPaths(){
gsap.set(".ufo-lights path", { drawSVG: false });
gsap.set(".ufo-lights svg", { opacity: 1});
	
gsap.set("#ufo-light-track", {strokeDasharray:"50,50", strokeDashoffset:"0%" });				

tl_ufo	
.to("#ufo-light-track",  {duration:12, strokeDasharray:"50,50", strokeDashoffset:"100%", ease: "none" });
}
heroAnimationPaths();





// Animate UFO ORBS
// ------------------------------------- //
const ufoTimeline = gsap.timeline({ delay:4 });


const getMinY = () => 450;
const getMaxY = () => 1300;
const getMinX = () => 0;
const getMaxX = () => window.innerWidth / 1;

// 2. Loop through each orb and attach a simple, infinitely repeating tween
const orbs = ["#orb-1", "#orb-2", "#orb-3"];

gsap.set(orbs,{opacity:0,});

for (let i = 0; i < orbs.length; i++) {
  const selector = orbs[i];
  const element = document.querySelector(selector);
  if (!element) continue;

  const startX = parseFloat(element.getAttribute("cx")) || 0;
  const startY = parseFloat(element.getAttribute("cy")) || 0;

  ufoTimeline.to(selector, {
    x: () => gsap.utils.random(getMinX(), getMaxX()) - startX,
    y: () => gsap.utils.random(getMinY(), getMaxY()) - startY,
    duration: () => gsap.utils.random(3, 6),
    ease: "sine.inOut",
    repeat: -1,        // Loops infinitely automatically
    repeatRefresh: true, // Forces GSAP to pick new random values on every loop
    onStart:OrbShow
  }, 0); // Starts all 3 animations at time 0
}

function OrbShow(){
gsap.to(orbs,{duration:1.5, opacity:1,});
} 
ufoTimeline.play();


// Animate UFO Beam
// ------------------------------- //
const ufoBeamTimeline = gsap.timeline();

ufoBeamTimeline.fromTo(".hero-ufo-beam", 
  { 
    opacity: 0 
  }, 
  { 
    opacity: 1, 
    duration: 1.2, 
    ease: "power2.out",
    onComplete: startPulseAnimation 
  }
);
function startPulseAnimation() {
 ufoBeamTimeline.to(".hero-ufo-beam", {
    // Creates a glowing blue tint around the PNG
    opacity:0.5,
    filter: "hue-rotate(200deg) saturate(200%)",
    duration: 1.5,
    repeat: -1,        
    yoyo: true,        
    ease: "sine.inOut" 
  });
}




// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
// HERO PLAY CONTROLLER 
//  When scrolled past 800 pixels pasies, resumes when scollred back
// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
window.addEventListener('scroll', function() {

    if (window.scrollY > 500) {
      tl_ufo.pause();        
      ufoTimeline.pause();  
      ufoBeamTimeline.pause(); 
      
    } else {
            tl_ufo.play();        
       ufoTimeline.play();  
      ufoBeamTimeline.play();    
    }
     
});



// SCROLLING ANIMATIONS
// ================================ //

let arch_cab = document.querySelectorAll('.file-cab');

gsap.set(arch_cab, { opacity: 0, y:20 });
gsap.set('.file-name, .file-info', { opacity: 0, y:20 });
gsap.set('.file-link', { opacity: 0, rotationY:180 });


// ANIMATE SECTION TITLES 
gsap.utils.toArray('.section_title').forEach(title => {
  const titleDelay = window.isInitialPreload ? 7 : 1;

  gsap.fromTo(title, 
    { opacity: 0, y: 30 },
    {
      opacity: 1,
      y: 0,
      duration: 0.5,
      delay: titleDelay,
      scrollTrigger: {
        trigger: title,
        start: 'top 80%',
        once: true // Ensures it never repeats when scrolling back up
      }
    }
  );
});

// ANIMATE SECTION CONTENTSS
ScrollTrigger.batch(arch_cab, { 
  start: 'top 80%', 
  onEnter: batch => { 
    const dynamicDelay = window.isInitialPreload ? 2 : 1; 

    let tl_arch_fx = gsap.timeline({ 
      onComplete: () => { window.isInitialPreload = false; } 
    }); 

    var arch_title = batch.map(el => el.querySelectorAll('.file-name')); 
    var arch_info = batch.map(el => el.querySelectorAll('.file-info')); 
    var arch_link = batch.map(el => el.querySelectorAll('.file-link')); 

    tl_arch_fx.to(batch, { duration: 1, opacity: 1, y: 0, transformOrigin: "center center", stagger: 0.2, ease: "power2.out" }, `+=${dynamicDelay}`) 
      .to(arch_title, { duration: 0.5, opacity: 1, y:0, stagger: 0.1 }, "<0.2") 
      .to(arch_info, { duration: 0.5, opacity: 1, y:0, stagger: 0.1 }, "<0.2") 
      .to(arch_link, { duration: 0.5, opacity: 1, rotationY:0, stagger: 0.1 }, "<0.2"); 
  }, 
  once: true 
});





// ROLLOVER ANIMATIONS
// ------------------------- //
// 1. Select the buttons that will trigger the hover effect
let demoButtons = document.querySelectorAll('.file-cab .demo-link'); 

// 2. Loop through each button to attach event listeners
demoButtons.forEach((button) => {
  // Find the specific parent container for this button
  let fileCab = button.closest('.file-cab');

  button.addEventListener('mouseenter', () => {
    // Animates the parent container, not the button
    gsap.to(fileCab, { 
      backgroundColor: "#324e6c", 
      duration: 0.3, 
      ease: 'power2.out' 
    });
  });

  button.addEventListener('mouseleave', () => {
    // Resets the parent container color on leave
    gsap.to(fileCab, { 
      backgroundColor: "#233b54", 
      duration: 0.3, 
      ease: 'power2.out' 
    });
  });
});







    
    

    


    

}, { scope: bgfx_ref_8 }); 
   // End of useGSAP







   










  
  return (
  


<main className="page-content page-id_archive" data-page-id="archive" ref={bgfx_ref_8}>
<HelmetProvider> 
<Fragment> 
      <Helmet>
        <title>Archive Page | Script, Plugins and Icons for Download</title>
        <meta name="description" content="An archive of my web developed scripts, plugins and downloadable graphics."/>
      </Helmet>
</Fragment>
</HelmetProvider>

<svg version="1.1" className="archive-transition-curtain transition-curtain" x="0px" y="0px"viewBox="0 0 191 191" xmlSpace="preserve">
<path className="st0" d="M95.5,190.5c-52.4,0-95-42.6-95-95s42.6-95,95-95s95,42.6,95,95S147.9,190.5,95.5,190.5z"/>
<path className="st1" d="M95.5,1C147.6,1,190,43.4,190,95.5S147.6,190,95.5,190S1,147.6,1,95.5S43.4,1,95.5,1 M95.5,0
	C42.8,0,0,42.8,0,95.5S42.8,191,95.5,191S191,148.2,191,95.5S148.2,0,95.5,0L95.5,0z"/>
</svg>



<div className="hero-container-wrap">   
<div className='hero-container'>
  <div className="hero-mask">

  <div className='mask-svg'>
    <svg viewBox="0 0 0 0" height="0" width="0">
      <defs> 
          <clipPath id="clipping" clipPathUnits="objectBoundingBox" transform="scale(0.00099, 0.00105)"> 
              <path id="dotmask" d="M853,0c0,357.9-290.1,648-648,648c-71.6,0-140.6-11.6-205-33.1v158.6C65.4,790.8,134.1,800,205,800
			c441.8,0,800-358.2,800-800H853z"/>
              <path id="hoopmask"  d="M0,0v501.1c63.2,25.9,132.4,40.2,205,40.2c298.9,0,541.3-242.3,541.3-541.3H0z"/>
	        </clipPath>
      </defs> 
    </svg>
  </div>
 




<div className='heroimage'>





<div className="orb-lights">
<svg className="orbs" version="1.1" viewBox="0 0 2400 1750">
  <defs>
    <radialGradient id="radial-gradient-orb-1" cx="1781.8" cy="803.4" fx="1781.8" fy="803.4" r="103.4" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#fff"/>
      <stop offset="0" stopColor="#fff" stopOpacity="1"/>
      <stop offset=".1" stopColor="#fff" stopOpacity=".7"/>
      <stop offset=".3" stopColor="#fff" stopOpacity=".5"/>
      <stop offset=".4" stopColor="#fff" stopOpacity=".4"/>
      <stop offset=".5" stopColor="#fff" stopOpacity=".2"/>
      <stop offset=".6" stopColor="#fff" stopOpacity=".1"/>
      <stop offset=".7" stopColor="#fff" stopOpacity="0"/>
      <stop offset=".9" stopColor="#fff" stopOpacity="0"/>
      <stop offset="1" stopColor="#fff" stopOpacity="0"/>
    </radialGradient>
   <radialGradient id="radial-gradient-orb-2" cy="983.4" fy="983.4" xlinkHref="#radial-gradient-orb-1"/>
    <radialGradient id="radial-gradient-orb-3" cx="1988.6" cy="922.5" fx="1988.6" fy="922.5" xlinkHref="#radial-gradient-orb-1"/>
  </defs>
  <g id="ORBS">
      <circle id="orb-3" className="orb" cx="1781.8" cy="803.4" r="103.4"/>
      <circle id="orb-2" className="orb2" cx="1781.8" cy="983.4" r="103.4"/>
      <circle id="orb-1" className="orb3" cx="1988.6" cy="922.5" r="103.4"/>
  </g>
</svg>
</div>





     <div className="ufo-container">
        <img className="ufo" src={heroimg_archive_top}  />
     </div>

    <div className="ufo-lights">
       <svg id="ufo-track-case" xmlns="http://www.w3.org/2000/svg" version="1.1"  viewBox="0 0 2400 1750">
     <defs>
    <radialGradient id="radial-gradient" cx="71.4" cy="1964.9" fx="71.4" fy="1964.9" r="16" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#fff"/>
      <stop offset=".7" stopColor="#fff" stopOpacity="0"/>
    </radialGradient>
  </defs>
          <g id="ufo-lights-track">
          <g id="track" className="st2">
             <path id="ufo-light-track" className="st0" d="M268.86,472.36c58.56-95.87,189.24-148.62,229.25-164.32,105.98-41.58,193.71-50.08,241.18-54.33,112-10.02,189.59,3.28,208.05,6.63,106.79,19.37,160.51,55.01,185.52,74.21,47.05,36.12,58.1,64.39,62.28,79.51,11.34,41.03-2.62,76.89-7.95,88.79-7.59,16.95-20.42,36.09-62.28,67.58-56.5,42.51-108.12,64.08-123.24,70.23-92.8,37.81-170.71,49.51-231.9,58.31-81.54,11.73-141.92,12.1-165.64,11.93-57.24-.42-98.4-5.46-116.61-7.95-43.54-5.96-79.33-11.11-123.24-29.15-29.38-12.07-59.77-24.96-86.13-55.66-10.15-11.82-27.28-31.76-31.8-60.96-1.77-11.43-4.21-41.04,22.53-84.81Z"/>
         </g>
      </g>
  
     </svg>
    </div>


<img className="hero-ufo-beam" src={heroimg_archive_beam }  />

    <img src={heroimg_archive}  />
</div>





  </div>

  <div className='hero-text'>
    <div className="page-h1" style={{ opacity: 0, visibility: 'hidden' }}>
     <h1>Archive</h1>
     <div className="h1-accent"><span></span></div>
    </div>
    <strong>Scripts, Plugins &amp; Icons</strong>
  </div>

</div>
</div>  













<div className="content">




<div className="page-archive">

<section>
<h2 className="section_title">JavaScript</h2>
   <div className="file-cab">
              <div className="file-name">Glitch Text FX</div>
              <div className="file-info"><p>This is the JavsScript plugin version of my Glitch text effect for use with headers. Requires the GSAP library.</p></div>
              <div className="file-link"><a className="demo-link" target="_blank" href="/plugins/glitch-js-plugin.html">Details</a></div>
   </div>
</section> 
<section>
            <h2 className="section_title">jQuery Plugins</h2>
            <div className="file-cab">
              <div className="file-name">Glitch Text FX</div>
              <div className="file-info"><p>Glitch is a text effect that randomly fluctuates each letter in a word with random characters. Link version and Header Text Version.</p></div>
              <div className="file-link"><a className="demo-link" target="_blank" href="/plugins/glitch.html">Details</a></div>
            </div>
            <div className="file-cab">
              <div className="file-name">Skill Gauge</div>
              <div className="file-info"><p>Add animated skill gauges to your website that respond to once scrolled to. Built in SVG images for optimization. Relies on the GSAP animation library.</p></div>
              <div className="file-link"><a className="demo-link" target="_blank" href="/plugins/skillgauge.html">Details</a></div>
            </div>
            <div className="file-cab">
              <div className="file-name">Tilt3D</div>
              <div className="file-info"><p>Tilt a specified html object in a 3D panning effect created by mouse movement. For Desktop computers only.</p></div>
              <div className="file-link"><a className="demo-link" target="_blank" href="/plugins/tilt3d.html">Details</a></div>
            </div>
            <div className="file-cab">
              <div className="file-name">CTA Flip</div>
              <div className="file-info"><p>Make a cool inteactive call-to-action. This plugin adds a flip in 3D effect to a clickable element. For Desktop computers only.</p></div>
              <div className="file-link"><a className="demo-link" target="_blank" href="/plugins/cta-flip.html">Details</a></div>
            </div>
            <div className="file-cab">
              <div className="file-name">CTA Slide</div>
              <div className="file-info"><p>Creates a slide out and over content window with center text area message. For Desktop computers only.</p></div>
              <div className="file-link"><a className="demo-link" target="_blank" href="/plugins/cta-slide.html">Details</a></div>
            </div>
            <div className="file-cab">
              <div className="file-name">BorderLine</div>
              <div className="file-info"><p>Add a animated border line animation to a call-to-action. For Desktop computers only.</p></div>
              <div className="file-link"><a className="demo-link" target="_blank" href="/plugins/borderline.html">Details</a></div>
            </div>
            <div className="file-cab">
              <div className="file-name">Statsometer</div>
              <div className="file-info"><p>Shows old-school type counter stats when scrolled to. Can customize for different messages instead of numeric values.</p></div>
              <div className="file-link"><a className="demo-link" target="_blank" href="/plugins/statsometer.html">Details</a></div>
            </div>
            <div className="file-cab">
              <div className="file-name">Mobi Table</div>
              <div className="file-info"><p>Changes a HTML table into a mobile freindly version for smaller screens.</p></div>
              <div className="file-link"><a className="demo-link" target="_blank" href="/plugins/mobitable.html">Details</a></div>
            </div>
            <div className="file-cab">
              <div className="file-name">Demo Box</div>
              <div className="file-info"><p>Creates a demonstration slide that you can easily navigate steps for demos to instructions.</p></div>
              <div className="file-link"><a className="demo-link" target="_blank" href="/plugins/demobox.html">Details</a></div>
            </div>
            <div className="file-cab">
              <div className="file-name">3D FlipViewer</div>
              <div className="file-info"><p>This small application was made to display in 3D a 2 sided printed flyer or busines card.</p></div>
              <div className="file-link"><a className="demo-link" target="_blank" href="/apps/3d-flip-viewer/index.html">Details</a></div>
            </div>
          </section>
             <section>
            <h2 className="section_title">WordPress Theme</h2>
            <div className="file-cab">
              <div className="file-name">Solar</div>
              <div className="file-info"><p>This started thme for developers comes with GSAP scrollTrigger and scrollSmother setup and ready to customize.</p></div>
              <div className="file-link"><a className="demo-link" target="_blank" href="/wordpress/themes/solar/index.html">Details</a></div>
            </div>
          </section>
          <section>
            <h2 className="section_title">WordPress Plugin</h2>
            <div className="file-cab">
              <div className="file-name">BusnHours</div>
              <div className="file-info"><p>This WordPress plugin displays a small animated business hours section on your webiste with customizeable notice colors. Easily add to your pages with a shortcode.</p></div>
              <div className="file-link"><a className="demo-link" target="_blank" href="/plugins/wordpress/busnhours.html">Details</a></div>
            </div>
          </section>
          <section>
            <h2 className="section_title">Icons</h2>
            <div className="file-cab">
              <div className="file-name">Social Media Icons</div>
              <div className="file-info"><p>A set of 14 round SVG hollow-cut soical media icons. Free download. Free usage, just credit back.</p></div>
              <div className="file-link"><a className="demo-link" target="_blank" href="/downloads/14-svg-social-media-icons/index.html">Details</a></div>
            </div>
          </section>

          </div>



    

</div>


</main>
  );



};

export default Archive;